export default {
"duplicate_delivery_component":"Choose separate deliveries for separate plan components. A person cannot be assigned twice to the same delivery.",
"requirement_change_requires_review":"An existing Optional requirement was retained. Review it explicitly before changing it to Required; its deadline has not been reset.",
"delivery": {"viewReusableSource":"View linked reusable workshop","sourceWorkshop":"Source workshop","scheduleRequirement":"Schedule this requirement","datesWhenAssigning": "Dates set when assigning", "defaultsHelp": "Defaults only; no booking or capacity is reserved.", "deliveryDate": "Delivery date and time", "instructor": "Instructor", "location": "Location", "availableCapacity": "Available places", "unavailable": "Not provided", "chooseOrCopy": "Choose another delivery / create a dated copy", "delivery": "Delivery for this assignment", "currentDelivery": "Current delivery (not available for a new booking)", "createDelivery": "Create a new dated delivery", "makeReusable": "Make workshop reusable", "conversionHelp": "Confirmation creates a linked reusable source of the original content. The original dated delivery, published plan version, attendees and history are retained. This assignment uses the separate delivery selected here.", "newDeliveryHelp": "A separate delivery will be created on confirmation, shared by all selected employees for this component. Cancelling creates no delivery.", "start": "Start", "end": "End", "locationType": "Location type", "meetingPoint": "Meeting point", "offSite": "Off site", "clubSpace": "Reserve a club space", "capacity": "Capacity for this delivery", "scheduleExisting": "The existing unscheduled requirement will be scheduled; no duplicate requirement will be created.", "retainedDeadline": "The existing completion deadline and requirement will be retained.", "loadError": "Delivery choices could not be loaded. Retry before selecting a delivery."},
"savedDraftChanges": "Saved unpublished changes",
"awaiting_scheduling": "Awaiting scheduling",
"past_delivery": "This delivery is in the past. Choose a future delivery.",
"booking_closed": "This delivery no longer accepts new bookings. Choose a future delivery.",
"occurrence_future_required": "Choose a future delivery date and time.",
"invalid_local_time": "Enter valid local start/end times, with the end after the start.",
"ambiguous_local_time": "This time occurs twice when the clocks change. Choose an unambiguous local time.",
"invalid_capacity": "Enter a whole capacity between 1 and 100,000.",
"instructor_not_assigned": "Choose an available instructor.",
"location_required": "Enter a location.",
"facility_required": "Choose a club space.",
"facility_unavailable": "The club space is not available at this time.",
"schedule_conflict": "The schedule conflicts with an existing reservation.",
"delivery_source_mismatch": "This delivery does not belong to the selected source workshop.",

"pastDeliveryWarning": "This delivery is in the past. New bookings are not allowed. Choose a future delivery before assigning a new place.",
"planItems": "Training items",
"planPreview": "View ordered training items",
"planVersions": "Published version history",
"planRetireHelp": "Retiring prevents this plan from being used for new assignments. Existing assigned versions and training history are retained.",
"nothingNewToAssign": "Nothing new to assign. All reviewed requirements already have an assignment and will be retained.",
"no_new_assignments": "Nothing new to assign. Existing assignments are retained.",

"qualificationNotifications": {
  "information_requested": "Qualification: more information requested",
  "verified": "Qualification verified",
  "rejected": "Qualification rejected"
},
"viewQualification": "View qualification",
"requestChanged": "This request has changed. The current record has been refreshed; check its status and history.",
"awaitingEmployeeResponse": "Awaiting the employee’s response.",
"document_unsupported": "Choose a PDF, PNG or JPEG file.",
"document_mismatch": "The file contents do not match its declared type. Export it again as PDF, PNG or JPEG and choose the new file.",
"document_empty": "This file is empty. Choose a file containing your supporting evidence.",
"document_oversized": "This file exceeds 10 MB. Choose a smaller PDF, PNG or JPEG.",
"document_malformed": "This file or upload is incomplete or malformed. Export it again and choose the new file.",

"qualificationRecoveryMismatch":"This saved qualification does not match this submission. Close this form and refresh your qualifications before continuing. No document has been uploaded.",
"qualificationSubmitRetry":"The qualification could not be submitted. Your fields and selected file have been kept. Retry when connected.",

"documentOptional": "Supporting document (optional)",
"documentHelp": "PDF, PNG or JPEG, up to 10 MB. Stored privately with your qualification.",
"chooseDocument": "Choose document",
"replaceDocument": "Replace document",
"removeDocument": "Remove document",
"uploadingDocument": "Saving your supporting document…",
"documentValidation": "Choose a non-empty PDF, PNG or JPEG no larger than 10 MB. Your previous selection has been kept.",
"documentPartial": "Your qualification was saved, but its supporting document was not saved. Retry here to attach it to the same qualification.",
"qualificationSaved": "Qualification saved. Complete the selected document upload before finishing.",
"retryDocument": "Retry document upload",
"uploadDocument": "Save supporting document",
"documentRetry": "The document could not be saved. Your selected file is retained. Retry the upload.",
"documentSaved": "Supporting document saved.",
"yourResponse": "Your response",
"reviewerMessage": "Reviewer’s message",
"responseHelp": "Add the requested document and save it, then write your response and send the information back for review. Uploading alone does not send your response.",
"trainingDetails": "Training details",
"assignmentActivity": "Assignment activity",
"assignmentActivityHelp": "Activity for this person’s training assignment, including deadline changes. Workshop attendance is recorded separately.",
"activitySubmitted": "Qualification submitted",
"activityResponded": "Information sent for review",
"activityReviewed": "Qualification reviewed",
"activityUpdated": "Record updated",
"activityActor": "By",
"olderActivity": "Older activity: further details were not recorded.",
"previousDeadline": "Previous deadline",
"newDeadline": "New deadline",
"reviewerHelp": "Qualification reviewers check qualifications submitted by staff. Instructors deliver workshops; instructor access does not include qualification review.",
"reviewerEnabled": "Can review qualifications",
"reviewerDisabled": "No qualification review access",
"you": "You",
"reviewSetupHelp": "Qualification review needs separate access. Ask someone who manages reviewer settings to allow qualification review for your account. Workshop requests shown here are separate.",
"reviewSettings": "Qualification reviewer settings",
"reasonHelp": "Enter a reason for the employee before choosing a decision. You cannot review your own qualification.",
"reviewInformation": "Request more information",
"reviewVerify": "Verify qualification",
"reviewReject": "Reject qualification",
"noHistory": "No past requests in your authorised review scope.",
"emptyReviewHelp": "You are up to date for the requests you are authorised to review.",
"plansEmpty": "No training plans yet. Create a plan to group and order reusable training requirements.",
"automaticEmpty": "No automatic assignments yet. Set up a published plan for eligible staff and choose when it starts.",
"deliveryCount": "Notifications",
"deliveryNext": "Next attempt",
"teamAccessFailed": "Team training access could not be checked.",
"checkAccess": "Check access",
"reviewer": "Qualification reviewers",
"grantReviewer": "Allow qualification review",
"revokeReviewer": "Remove review access",
"respond": "Send information for review",
 team:{"requestUnavailable":"This request is no longer available. Choose another request.","resumePlan":"Continue editing training plan","requestHistory":"Request history","qualificationScope":"Showing qualifications you are authorised to view.","title": "Team training", "description": "Manage staff training, assignments and development.", "home": "Academy home", "homeDescription": "View learning activity, enrolments and attendance across your club.", "personalDescription": "Your training, workshops and qualifications.", "overview": "Team overview", "recent": "Recent assignments", "noRecent": "No recent assignments.", "viewResults": "View results", "search": "Search your team", "aboutProgress": "About progress records", "progress": "Progress", "requirement": "Requirement", "moreFilters": "More filters", "intro": "Find a colleague, check their training or assign something new.", "assign": "Assign training", "review": "Review requests", "manage": "Manage training", "filter": "Filter", "people": "People", "person": "Person", "training": "Training", "deadline": "Next deadline", "view": "View training", "noAssignments": "No training assigned", "requiredCount": "Required: {count}", "optionalCount": "Optional: {count}", "overdueCount": "Overdue assignments: {count}", "noDeadline": "No upcoming deadline", "viewPerson": "View training for {name}", "empty": "No colleagues match your search. Try another name or clear the filter.", "pagination": "Team pages", "back": "Back to team training", "plans": "Training plans", "automatic": "Automatic assignments", "settings": "Settings", "history": "Assignment history", "plansHelp": "Create and maintain reusable training plans.", "automaticHelp": "Assign training plans automatically to eligible staff.", "settingsHelp": "Manage reviewers and troubleshoot notification delivery.", "historyHelp": "Read previous assignment batches and their saved results.", "unavailable": "Count unavailable", "action": "Choose an action", "chooseTraining": "Training", "details": "Details", "confirm": "Review", "saved": "Training saved", "viewAssigned": "View assigned training", "selected": "Selected: {count}", "selectMatching": "Select all eligible people matching this loaded list ({count})", "planDetails": "Requirements and deadline offsets use the selected published training-plan version. Review each date before assigning.", "eligible": "Eligible for assignment", "excluded": "Excluded from new places. Review the existing training or explicitly change Optional to Required.", "reviewHelp": "Check the exact people, training, dates, available places and exceptions. Confirm to save these assignments.", "cancel": "Cancel", "continue": "Continue", "confirmAssign": "Confirm and assign", "decisionSaved": "Decision saved. Notification delivery can be checked in Settings.", "pending": "Pending requests", "workshop": "Workshop request", "qualification": "Qualification submission", "noRequests": "No requests need your review.", "backRequests": "Back to requests", "selectRequest": "Select a request to review its details.", "name": "Name", "addOrder": "Add and order training", "requirements": "Requirements and deadline offsets", "publishReview": "Review and publish", "createPlan": "Create training plan", "createPolicy": "Set up automatic assignments", "eligibleStaff": "Eligible staff", "effectiveDate": "Effective date", "existingStaff": "Include existing staff", "activate": "Review and activate", "estimated": "Eligible staff shown here are an estimate. Confirmed assignments are recorded after the policy runs.", "draft": "Draft", "published": "Published", "retired": "Retired", "version": "Version", "saveDraft": "Save draft", "publishPlan": "Save and publish", "finish": "Finish", "backManage": "Back to Manage training"},
 employee_withdrawal: "You cancelled your place",
 done: "Done",
 attendanceNotRecorded:"Attendance not recorded",
 viewDetails:"View details", openSection:"Open",
 shownInSection: "shown in this section",
 tiles:{"requests": {"count":"Requests: {count}","title": "My requests", "description": "Track requests to join workshops."}, "available": {"count":"Workshops available: {count}","title": "Available workshops", "description": "Browse workshops you can join."}, "qualifications": {"count":"Qualifications: {count}","title": "My qualifications", "description": "Submit and track your qualifications."}, "history": {"count":"History records: {count}","title": "Learning history", "description": "View your past training records."}},
  usability: {"assignmentStatus":"Assignment status","descriptionUnavailable":"No description is available.","trainingStatus":"Training status","closeDetails":"Close workshop details","aboutWorkshop":"About this workshop","assignMore": "Assign more staff", "startMoreFailed": "Could not start another assignment. Your saved result is retained. Retry when connected.","restoringAssignment": "Check the saved assignment to view its current results. Your choices are retained; do not assign again.","learningProgress":"Learning progress","published": "Workshop published", "detailsPublished": "Workshop details published", "viewWorkshop": "View Workshop", "backWorkshop": "Back to workshop", "when": "When", "where": "Where", "description": "Description", "viewDetails": "View details", "attendanceNotRecorded": "Attendance not recorded", "availabilityUnavailable": "Temporarily unavailable. Retry to check availability.", "confirmedPlaces": "Confirmed places", "existingAssignments": "Existing assignments", "exceptions": "Places needing attention", "noStaff": "There are no staff in your authorised team. Contact your administrator if someone is missing.", "bookingStatus": "Booking status"},
  reviewerSearch: 'Search reviewer name or role',
  allRequirements: 'All requirements',
  requirement_change_unsupported: 'Existing Required training is retained. Review it in Team training before changing the requirement.',
  manager_action_required: 'Ask your manager to change Required training.',
  cancellation_not_permitted: 'Cancellation is unavailable after delivery or within the booking cancellation window.',
"choosePathway": "Choose a pathway",
"chooseWorkshop": "Choose a workshop",
"allStatuses": "All statuses",
"chooseEmployee": "Choose an employee",
"allDepartments": "All departments",
"allRoles": "All roles",
"chooseOption": "Choose an option",
"changed_to_required": "Changed to Required",
"staff_join_unavailable": "Staff joining is unavailable for this workshop.",

  "joining": {"decisionSaved":"The server saved this decision.","available":"Available", "unavailable":"Unavailable","alreadyEnrolled":"Already enrolled","bookingRecovery":"Assignment needs booking recovery","cancelledHistory":"Previous place cancelled; eligible to book again","changeToRequired":"Change to Required","recoverBooking":"Recover booking","upgradePlaceHelp":"This updates the existing training requirement and retains the booked place. Set the required date, then review and confirm.","checkingEnrolments":"Checking current enrolments…","enrolmentsUnavailable":"Current enrolments could not be checked. Refresh before selecting staff.","noteToEmployee":"Note to employee (optional)","noteVisible":"Your note will be visible to the employee. Maximum 2,000 characters.","awaitingReview":"Requests awaiting review","requestedOn":"Requested on","full":"Full","reviewRefresh":"Decision saved. Refresh current requests and places; do not submit the decision again.","refreshRequests":"Refresh requests and places","youCancelled":"You cancelled your place","earlyCheckIn":"Early check-in records attendance only. It does not mark this workshop delivered. Absence is available after the session starts.","attendanceUnavailable":"Before the start, only Present can be recorded on the same club-local day.","deliveryUnavailable":"Delivery is available after the scheduled start.","saveJoiningFailed": "The joining rule could not be saved. Check your access and connection, then retry. Your selection has been kept.", "joiningSavedRefreshFailed": "Joining rule saved. Current data could not be refreshed; the rule shown is the acknowledged save, not a fresh verification. Refresh current data before editing again.", "refreshJoining": "Refresh current joining rule","editJoining":"Edit joining rules","cancelJoining":"Cancel","discardJoining":"Discard your unsaved joining-rule changes?","editJoiningHelp":"Choose a policy, then save to apply it to this run.","oneStaffAssigned":"1 staff member assigned","staffAssignedCount":"{count} staff members assigned","onePlaceConfirmed":"1 place confirmed","placesConfirmedCount":"{count} places confirmed","recheckAvailability":"Refresh available places","restoredResult":"Saved assignment results. Available places are checked separately.","backWorkshop":"Back to workshop","stepCompleted":"Completed","selectionHelp":"Selecting staff does not reserve places. Availability is checked when you assign.","selectLoaded":"Select all matching staff in this loaded list","clearSelection":"Clear selection","outsideSearch":"Selected outside this search","noMatchingStaff":"No matching staff. Try another name or role.","continueRequirements":"Continue: Set requirements","continueReview":"Continue: Review and assign","staffAssigned":"staff assigned","placesConfirmed":"places confirmed","trainingAssigned":"Training assigned","assignMore":"Assign more staff","availabilityUnknown":"Availability unavailable","sessionExpired":"Your sign-in could not be verified. Sign in again before rechecking this result.","requestAcknowledged":"The server saved this decision. The latest request list could not be refreshed; recheck current access and status.","serverValidated":"Rechecked with the server for your current account and permissions.","previousAcknowledgment":"The server acknowledged this assignment earlier. The latest update failed; recheck it before relying on current access or availability.","previousAcknowledgmentDenied":"The earlier assignment was saved, but your current permissions no longer allow access to these results.","recheckAssignment":"Recheck saved assignment",
    "action_required": 'Place not confirmed. Contact your manager.',
  "workshopDate": "Workshop date",
  "conditions": "Booking and cancellation conditions",
  "hours": "hours",
  "requiredCancellation": "Required training needs manager action to change the assignment or place.",
  "cancellationHelp": "Optional places can be cancelled before delivery within the booking cancellation window. Paid bookings need the authorised refund workflow.",
  "cancelPlace": "Cancel optional place",
  "cancelled": "Workshop cancelled",
  "unusualHours": "This session starts before 7 AM, ends after 10 PM, or lasts more than eight hours. Confirm these times are intentional.",
  "howStaffJoin": "How staff join",
  "saveJoining": "Save joining rule",
  "reviewRequests": "Review team requests",
  "reviewUnavailable": "This action is unavailable or your team scope changed. Refresh and try again.",
  "selectWorkshop": "Choose a workshop for guided assignment, or open pathway assignment below.",
  "assignTraining": "Assign Training",
  "view": "View workshop",
  "reviewBeforeJoining": "Read the workshop details before confirming your choice.",
  "manager_only": "Manager assigns staff only",
  "automatic": "Staff can join automatically",
  "approval": "Staff request approval",
  "manager_onlyHelp": "A manager chooses who attends and assigns their training.",
  "automaticHelp": "Eligible staff can confirm a place themselves, subject to availability.",
  "approvalHelp": "Staff request a place; their manager reviews it before a place is confirmed.",
  "join": "Join workshop",
  "request": "Request a place",
  "requests": "Enrolment requests",
  "pending": "Awaiting approval",
  "requested": "Workshop place requested",
  "confirmed": "Place confirmed",
  "blocked": "Request unresolved",
  "declined": "Request declined",
  "withdrawn": "Request withdrawn",
  "blockedHelp": "The place could not be confirmed. Your manager can review availability and retry.",
  "notReserved": "Pending requests do not reserve a place or start a training deadline.",
  "pendingDemand": "Pending demand",
  "noRequests": "No workshop requests yet.",
  "reason": "Decision reason",
  "approve": "Approve and book",
  "decline": "Decline",
  "withdraw": "Withdraw request",
  "retryHelp": "You can deliberately apply again from Available workshops if joining is still open.",
  "history": "Request history",
  "historyEvent": "Request updated",
  "requestNotice": "Open My Learning or Staff training to see the workshop request and next action.",
  "places": "Available places",
  "duration": "Duration",
  "minutes": "minutes",
  "finance": "Paid training needs the authorised payer and finance workflow. Contact your manager.",
  "workshopDateHelp": "Voluntary workshop enrolment uses the last session date as its workshop date, not an extra completion obligation.",
  "choose": "Choose staff",
  "expectations": "Set requirements",
  "review": "Review and assign",
  "confirm": "Confirm",
  "choosePeople": "Choose at least one person from your authorised team.",
  "missingDates": "Enter a valid assignment date and an explicit deadline.",
  "savedRefresh": "Assignment saved. Refresh the results; do not submit another assignment.",
  "population": "Who will receive the assignment?",
  "selected": "Selected staff",
  "department": "Department",
  "role": "Role",
  "all": "All staff I manage",
  "chooseFilter": "Choose a group",
  "search": "Search name or role",
  "selectedCount": "Selected people",
  "requirement": "Requirement",
  "required": "Required",
  "optional": "Optional",
  "requiredHelp": "Required training is an explicit manager instruction with the deadline you set.",
  "optionalHelp": "Optional training is an invitation; it is separate from workshop joining rules.",
  "deadline": "Training deadline",
  "assignmentDate": "Assignment date",
  "advanced": "Advanced options",
  "reviewHelp": "Review the exact people, existing places and exceptions before assigning.",
  "person": "Person",
  "result": "What will happen",
  "upgrade": "Change Optional to Required with audit; keep the existing place.",
  "existingPlace": "Keep the confirmed place",
  "existingAssignment": "Keep the existing assignment",
  "assignAndBook": "Assign training; check availability and confirm a place if available",
  "back": "Back",
  "saving": "Saving…",
  "continue": "Continue",
  "assign": "Assign reviewed staff",
  "saved": "Assignment saved",
  "participants": "View participants",
  "teamTrainingHelp": "See your team’s assigned training, deadlines and progress.",
  "matrix": "Team training"
},
  assignmentRunHelp: "Maximum places: {capacity}. Selected employees are separate. Preview checks existing assignments, your team scope and available places before saving. Paid training still requires authorised finance booking.",
  assignmentRunUnavailable: "This run is unavailable for staff assignment. Check it is published and intended for staff, or ask the appropriate team manager.",
  "staffReference": "Staff reference",
  "jobSent": "Delivered to Inbox",
  "jobFailed": "Delivery failed; retry scheduled",
  "jobPending": "Notification pending",
  "jobSuppressed": "Suppressed by current delivery rules",
  "booking_cancelled": "The booked place has been cancelled. The assignment remains; request a new place or contact your manager.",
  "evidence_storage_unavailable": "Private evidence storage is unavailable. Your submission is retained; retry the document upload.",
  "renewOffering": "New offering for renewal (optional)",
  "renewal_booking_required": "This cycle needs a new booking or offering. Your manager can select a new offering; prior bookings and evidence have not been reused.",
  "singleTraining": "Single published training (alternative to a pathway)",
  "financialBooking": "Open authorised Academy booking workspace",
  "identity_action_required": "Staff sign-in identity needs configuration; the canonical Staff learner can still be assigned.",
  "scheduled": "Scheduled",
  "delivered": "Delivered",
  "legacyHistory": "Recorded learning history",
  "enrolmentHistory": "Enrolment history",
  "legacyHistoryMeaning": "These are recorded participation and progress facts, not outstanding assignments or accreditation.",
  "notAssignedMeaning": "No assignment has been recorded for this pathway (or any training when no pathway is selected). This is not outstanding training.",
  "legacyRecognition": "Existing qualification register evidence.",
  "valid": "Recorded valid",
  "expiring_soon": "Expiring soon",
  "missing_expiry": "Expiry date unavailable",
  "archived": "Archived",
  "onlineSource": "Existing online module",
  "publishOnline": "Publish online training reference",
  "legacyProgress": "Legacy progress evidence ID",
  "linkLegacy": "Link legacy evidence",
  "present": "Present",
  "absent": "Absent",
  "late": "Late",
  "excused": "Excused",
  "myLearning": "My Learning",
  "training": "Staff training",
  "required": "Assigned learning",
  "optional": "Available workshops",
  "history": "Learning history",
  "pathways": "Training plans",
  "matrix": "Team training",
  "overdue": "Overdue",
  "evidence": "External qualifications",
  "review": "Evidence review",
  "policies": "Automatic assignments",
  "notifications": {
    "assigned": "Training assigned",
    "due": "Training deadline approaching",
    "overdue": "Team training overdue",
    "body": "Open your learning workspace to see the assignment, deadline and next action."
  },
  "loading": "Loading learning…",
  "empty": "No records to show.",
  "error": "Learning could not be loaded. Please retry.",
  "retry": "Retry",
  "denied": "You do not have permission for this action.",
  "save": "Save",
  "publish": "Publish",
  "retire": "Retire",
  "edit": "Edit",
  "cancel": "Cancel assignment",
  "withdraw": "Withdraw assignment",
  "renew": "New learning cycle",
  "deadline": "Change deadline",
  "reason": "Reason",
  "due": "Due date",
  "assignmentDate": "Assignment date",
  "dueDays": "Days from assignment",
  "mandatory": "Required",
  "optionalLabel": "Optional",
  "name": "Name",
  "title": "Training plan name",
  "offering": "Training",
  "department": "Department",
  "role": "Role",
  "selected": "Selected staff",
  "all": "All authorised staff",
  "scope": "Population",
  "preview": "Preview assignment",
  "commit": "Assign previewed population",
  "created": "Created",
  "already_assigned": "Already assigned",
  "excluded": "Excluded",
  "pending": "Pending verification",
  "failed": "Failed",
  "count": "People: {count}",
  "total": "Records: {count}",
  "exceptions": "Exceptions",
  "outcomes": "Assignment outcomes",
  "refreshPreview": "Population or availability changed. Refresh the preview.",
  "previous": "Previous",
  "next": "Next",
  "details": "Details and evidence",
  "close": "Close",
  "book": "Request workshop place",
  "confirmed": "Place confirmed",
  "action_required": "Booking action required",
  "blocked": "Blocked — action required",
  "online_pending": "Online learning awaits a supported player. Review training details and contact your manager for supported materials.",
  "not_started": "Not started",
  "in_progress": "Recorded progress",
  "recorded_completed": "Recorded completion",
  "assigned": "Assigned",
  "cancelled": "Cancelled",
  "withdrawn": "Withdrawn",
  "evidenceMeaning": "Attendance and legacy progress are evidence of activity. They do not establish assessed competence or accreditation.",
  "recognition": "Recognition",
  "noRecognition": "No current recognition is recorded.",
  "workshops": "Workshop booking and attendance",
  "instructor": "Instructor",
  "location": "Location",
  "attendance": "Recorded attendance",
  "unavailable": "Content or offering unavailable. Contact your manager.",
  "qualification": "Qualification name",
  "issuer": "Original issuer",
  "issued": "Issue date",
  "expires": "Expiry date",
  "reference": "Supporting reference",
  "notes": "Notes",
  "submit": "Submit for verification",
  "document": "Supporting document (PDF, PNG or JPEG, maximum 10 MB)",
  "upload": "Upload private document",
  "download": "Download private document",
  "expired": "Expired evidence",
  "information_requested": "More information requested",
  "verified": "Verified evidence",
  "rejected": "Evidence rejected",

  "reviewReason": "Review reason",
  "verificationBoundary": "Verification checks external evidence. It does not issue an Academy award or complete assigned training.",
  "fixed": "This assignment uses a fixed preview population.",
  "ongoing": "Activate automatic assignments",
  "effective": "Effective date",
  "includeExisting": "Include existing staff",
  "prospective": "Prospective joiners and role changes only",
  "active": "Active",
  "paused": "Paused",
  "disabled": "Disabled",
  "pause": "Pause",
  "resume": "Resume",
  "disable": "Disable permanently",
  "policyBoundary": "Policies create one cycle per eligible person. New renewals require an explicit new cycle. History is retained when roles change.",
  "addComponent": "Add component",
  "remove": "Remove",
  "up": "Move up",
  "down": "Move down",
  "saved": "Saved",
  "filter": "Apply filters",
  "dueFrom": "Due from",
  "dueTo": "Due to",
  "progress": "Evidence state",
  "lifecycle": "Assignment lifecycle",
  "notAssigned": "Not assigned",
  "financial_action_required": "Use the authorised financial booking workflow; no charge or seat has been created.",
  "offering_full": "Workshop full",
  "inactive_staff": "Inactive staff",
  "offering_not_ready": "Training unavailable",
  "onlinePendingShort": "Online content pending",



  "jobStatus": "Notification operations",
  "revision": "Revision",
  "validation": "Check the required fields and dates.",
  "invalid_document": "Use a PDF, PNG or JPEG document up to 10 MB.",
  "invalid_evidence_dates": "Issue date cannot be in the future; expiry cannot precede issue.",
  "stale_revision": "This record changed. Refresh before editing.",
  "request_key_required": "The request identity is missing. Retry from this page.",
  "training_source_version_ambiguous": "This legacy module already has a published online reference. Use its existing version.",
  "training_evidence_not_relevant": "The recorded progress does not belong to this assigned training version and learning cycle.",
  "training_reference_conflict": "The referenced record is unavailable or conflicts with an existing record.",
  "not_found": "The record is unavailable.",
  "policyError": "Last policy evaluation error",
  "notPermitted": "This workspace is unavailable to your staff account.",
  "sectionUnavailable": "This section is unavailable until your learning can be loaded. Use Retry above.",
  "profileDescription": "Your training, workshops and qualifications",
  "openLearning": "Open My Learning",
  "overview": "Overview",
  "myTraining": "My Training",
  "upcoming": "Upcoming Workshops",
  "historyRecognition": "Learning History and Recognition",
  "yourDevelopment": "Learning and development",
  "welcome": "Your next steps, in one place",
  "overviewHelp": "Review your assigned training, plan workshop attendance and keep your qualifications up to date.",
  "assignmentTotalHelp": "All recorded assignments, including historical cycles.",
  "nextAction": "Next action",
  "viewTraining": "View training",
  "noPriority": "No outstanding work on this page. Explore development or check your qualifications.",
  "priorityVisible": "Priorities are based on the assignments on this page. Use My Training pagination to see more.",
  "dateUnavailable": "Not available",
  "refreshing": "Updating learning…",
  "loadingWorkshops": "Loading confirmed workshop details…",
  "workshopsError": "Workshop details could not be loaded. Your assignments are retained.",
  "noWorkshops": "No confirmed upcoming workshops on this page. Request a place through your training details.",
  "workshopsVisible": "Workshops shown belong to confirmed assignments on this page.",
  "onlineAvailability": "Online materials are awaiting a supported learning player. See the details for availability.",
  "workshopDevelopment": "Develop your skills through a workshop. Request training, then check the details for a place.",
  "requestDevelopment": "Request training",
  "noDevelopment": "No optional development is available right now.",
  "recordedSource": "Recorded learning activity",
  "noHistory": "No recorded learning activity yet.",
  "noEnrolments": "No enrolment history yet.",
  "recognitionHelp": "Existing recognition from your qualification register. Expired evidence is historical; it is not current recognition.",
  "noExistingRecognition": "No existing recognition is recorded.",
  "noQualifications": "Keep your external qualifications here. Add one to submit it for verification.",
  "noTraining": "No training is assigned on this page.",
  "addQualification": "Add Qualification",
  "qualificationHelp": "Enter the qualification details and optionally attach a private supporting document before submitting. Your draft is kept within this signed-in session.",
  "sectionHelp": {
    "requests": 'Review workshop place requests from your current authorised team.',
    "overview": "Your next action and assigned learning summary",
    "training": "Assignments, deadlines, booking and evidence status",
    "workshops": "Confirmed upcoming sessions, location and instructor",
    "development": "Optional training and booking requirements",
    "qualifications": "Private external qualifications and review",
    "history": "Recorded activity, enrolments and existing recognition",
    "pathways": "Configure training pathways and online references",
    "preview": "Preview and assign the exact staff population",
    "policies": "Manage ongoing assignment policies",
    "matrix": "Review training assignments and deadlines",
    "review": "Review qualification evidence",
    "notifications": "Check training notification delivery"
  }
};
